import { CaretRight } from "@phosphor-icons/react";

type CardButtonProps = {
  children: React.ReactNode;
  additionalClasses?: string;
  dataTestId?: string;
  style?: React.CSSProperties;
  id?: string;
  handleClick?: () => void;
};

export function CardButton({
  additionalClasses,
  children,
  dataTestId,
  style,
  id,
  handleClick,
}: CardButtonProps) {

  return (
    <button
      className={`btn-block bg-white rounded p-4 border ${additionalClasses}`}
      style={style}
      data-testid={dataTestId}
      id={id}
      onClick={handleClick}
    >
      <div className="d-flex">
        <div className="btn-block">
          {children}
        </div>
        <CaretRight
          size={20}
          weight="bold"
          className="mt-1_5 ml-3_5"
        />
      </div>
    </button>
  );
}
